import { create } from 'zustand';

interface OpenDelegationEntryState {
  openEntryId: string | null;
}

interface OpenDelegationEntryActions {
  setOpenDelegationEntry: (entryId: string | null) => void;
  reset: () => void;
}

type OpenDelegationEntryStore = OpenDelegationEntryState &
  OpenDelegationEntryActions;

// Tracks which InboxEntry currently has its AgentDelegationPlanModal open (the
// per-row "expand" view), so useAgentDelegationBrowserNotifier can skip the
// toast/browser-notification for a delegation status change on the entry the user is
// already looking at. AgentDelegationPlanModalTrigger registers/unregisters itself as
// the modal opens/closes. The InboxEntryDetailsModal case is covered separately by the
// doboxId URL param (the already-existing source of truth for that modal).
export const useOpenDelegationEntryStore = create<OpenDelegationEntryStore>(
  (set) => ({
    openEntryId: null,
    setOpenDelegationEntry: (entryId) => set({ openEntryId: entryId }),
    reset: () => set({ openEntryId: null }),
  }),
);
